export const getLocalCartUuid = () => localStorage.getItem('cart-uuid');

export const updateLocalCartUuid = (cartUuid: string | null) =>
  cartUuid
    ? localStorage.setItem('cart-uuid', cartUuid)
    : localStorage.removeItem('cart-uuid');
